import React, { useState, useEffect } from "react";
import { db } from "../../firebase.config";
import {
  collection,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "./Tracking.scss";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import atelierCaveDark from "react-syntax-highlighter/dist/esm/styles/hljs/atelier-cave-dark";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

function Tracking() {
  const [tracking, setTracking] = useState([]);
  const [popupActive, setPopupActive] = useState(false);
  const [form, setForm] = useState({
    client: "",
    assets: "",
    code: "",
    desc: "",
    docs: "",
  });
  const [selectedTracking, setSelectedTracking] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const trackingCollectionRef = collection(db, "tracking");

  useEffect(() => {
    const unsubscribe = onSnapshot(trackingCollectionRef, (snapshot) => {
      setTracking(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.values(form).some((f) => !f)) {
      alert("Please fill out all the fields");
      return;
    }
    await addDoc(trackingCollectionRef, form);
    setForm({ client: "", assets: "", code: "", desc: "", docs: "" });
    setPopupActive(false);
  };

  const removeTracking = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (confirmed) {
      await deleteDoc(doc(db, "tracking", id));
      if (selectedTracking?.id === id) {
        setSelectedTracking(null);
      }
    }
  };

  const handleCopyCode = async (code) => {
    await navigator.clipboard.writeText(code);
    alert("Code copied to clipboard!");
  };

  const filteredTracking = tracking
    .filter((t) =>
      t.client.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.client.localeCompare(b.client));

  return (
    <>
    <Header />
    <div className="App">
      <div className="functions-wrapper">
        {/* Sidebar */}
        <Sidebar>
          <div className="toolbar">
            <button onClick={() => setPopupActive(true)}>Add Tracking</button>
          </div>
          <input
            type="text"
            placeholder="Search by client..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {filteredTracking.map((item) => (
            <div
              key={item.id}
              className={`snippet-preview ${
                selectedTracking?.id === item.id ? "active" : ""
              }`}
              onClick={() => setSelectedTracking(item)}
            >
              {item.client.toLowerCase()}
            </div>
          ))}
        </Sidebar>

        {/* Main content */}
        <div className="function-details">
          {selectedTracking ? (
            <>
              <h2>{selectedTracking.client.toLowerCase()}</h2>
              <div className="description">
                <h4>Description</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: selectedTracking.desc,
                  }}
                />
              </div>

              <div className="assets">
                <h4>Assets</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: selectedTracking.assets,
                  }}
                />
              </div>

              <div className="docs">
                <h4>Docs</h4>
                <a
                  href={selectedTracking.docs}
                  target="_blank"
                  rel="noopener noreferrer"
                  dangerouslySetInnerHTML={{ __html: selectedTracking.docs }}
                />
              </div>

              <div className="code">
                <h4>Code</h4>
                <SyntaxHighlighter language="javascript" style={atelierCaveDark}>
                  {selectedTracking.code}
                </SyntaxHighlighter>
              </div>

              <div className="buttons">
                <button onClick={() => handleCopyCode(selectedTracking.code)}>
                  Copy Code
                </button>
                <button
                  className="remove"
                  onClick={() => removeTracking(selectedTracking.id)}
                >
                  Remove
                </button>
              </div>
            </>
          ) : (
            <p>Select a tracking entry to view details</p>
          )}
        </div>
      </div>

      {/* Add tracking modal */}
      {popupActive && (
        <div className="popup">
          <div className="popup-inner">
            <h2>Add Tracking</h2>
            <form onSubmit={handleSubmit}>
              {["client", "desc", "code", "assets", "docs"].map((field) => (
                <div className="form-group" key={field}>
                  <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                  <textarea
                    value={form[field]}
                    onChange={(e) => setForm({ ...form, [field]: e.target.value })}
                  />
                </div>
              ))}
              <div className="buttons">
                <button type="submit">Submit</button>
                <button
                  type="button"
                  className="remove"
                  onClick={() => setPopupActive(false)}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default Tracking;
